// Option lists shared by the Brand page and the text tools.

export const TONE_OPTIONS = [
  { value: 'professional', label: 'Professional', description: 'Formal, polished language with authoritative voice' },
  { value: 'casual', label: 'Casual', description: 'Relaxed, conversational like talking to a friend' },
  { value: 'friendly', label: 'Friendly', description: 'Warm, welcoming without being too casual' },
  { value: 'luxury', label: 'Luxury', description: 'Sophisticated vocabulary emphasizing exclusivity' },
  { value: 'playful', label: 'Playful', description: 'Fun, creative language that entertains' },
  { value: 'technical', label: 'Technical', description: 'Precise, specification-focused with details' }
];

// Product categories offered by the Brand Preferences page, the description tool,
// the listing agent and the social tool. Each renders its own empty first option.
export const CATEGORY_OPTIONS = [
  { value: 'clothing', label: 'Clothing & Apparel' },
  { value: 'electronics', label: 'Electronics & Gadgets' },
  { value: 'home', label: 'Home & Furniture' },
  { value: 'beauty', label: 'Beauty & Personal Care' },
  { value: 'food', label: 'Food & Beverages' },
  { value: 'health', label: 'Health & Wellness' },
  { value: 'toys', label: 'Toys & Games' },
  { value: 'sports', label: 'Sports & Outdoors' },
  { value: 'books', label: 'Books & Media' },
  { value: 'jewelry', label: 'Jewelry & Accessories' },
  { value: 'art', label: 'Art & Crafts' },
  { value: 'pets', label: 'Pet Supplies' },
  { value: 'other', label: 'Other' }
];

export const LANGUAGE_OPTIONS = [
  { value: 'english', label: 'English' },
  { value: 'spanish', label: 'Spanish' },
  { value: 'french', label: 'French' },
  { value: 'german', label: 'German' },
  { value: 'italian', label: 'Italian' },
  { value: 'portuguese', label: 'Portuguese' },
  { value: 'dutch', label: 'Dutch' },
  { value: 'chinese', label: 'Chinese' },
  { value: 'japanese', label: 'Japanese' },
  { value: 'korean', label: 'Korean' },
  { value: 'arabic', label: 'Arabic' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'russian', label: 'Russian' },
  { value: 'turkish', label: 'Turkish' }
];
